module.exports = __webpack_public_path__ + "img/hr-rock-huge-09.6e408ad7.png";